import React, { useEffect } from "react";
import Navbar from "../common/Navbar";
import DigitalSeo from "../components/service/DigitalSeo";
import Footer from "../common/Footer";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const DigitalMarketingSeo = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="top marketing agency for leads Chennai,
                   top marketing agency for leads India,
                   lead generation with google ads Chennai,
                   lead generation with google ads India,
                   business leads generation Chennai,
                   business leads generation India,
                   online leads for business Chennai,
                   online leads for business India"
        />
        <title>Search Engine Optimization Services | SEO Services</title>
        <meta
          name="description"
          content="Get expert SEO services and search engine optimization to improve website rankings, drive organic traffic, and increase conversions with measurable results."
        />
      </Helmet>
      <Navbar />
      <DigitalSeo />
      <Footer />
    </>
  );
};

export default DigitalMarketingSeo;
